// WhatsApp messaging is switched off. The API refuses to send whatever
// this says; this only stops offering a button that would be refused.
// Set REACT_APP_WHATSAPP_ENABLED=true at build time to bring it back.
export const WHATSAPP_ENABLED = process.env.REACT_APP_WHATSAPP_ENABLED === 'true'
